import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { getNodeDisplayLabel, useFlowDisplayLanguage } from '../../displayLanguage';
import { CardShell } from '../CardShell';

const formatSelection = (language: 'en' | 'ja') => language === 'en'
  ? 'Measure Distance'
  : '距離を測る';

export const TofNodeView = memo(function TofNodeView() {
  const displayLanguage = useFlowDisplayLanguage();

  return (
    <CardShell
      kind="tof"
      accent="red"
      title={getNodeDisplayLabel('tof', displayLanguage)}
      summary={formatSelection(displayLanguage)}
    >
      <Handle type="target" position={Position.Left} className="!bg-red-500" />
      <Handle type="source" position={Position.Right} className="!bg-red-500" />
    </CardShell>
  );
});
